import { t } from 'i18next';
import React, { FC } from 'react';

import { useCurrentActor } from '../../hooks/useCurrentActor';
import SignInFormLink from '../Auth/SignInFormLink';

import NavbarLink from './NavbarLink';

const NavbarSignIn: FC = () => {
  const { actorType } = useCurrentActor();

  if (actorType !== 'GuestUser') {
    return null;
  }

  return (
    <React.Fragment>
      <SignInFormLink Component={NavbarLink} label={t('auth.newSessionLink')} />
    </React.Fragment>
  );
};

export default NavbarSignIn;
